import { render, staticRenderFns } from "./PermohonanThanks.vue?vue&type=template&id=61ef0d63&"
import script from "./PermohonanThanks.vue?vue&type=script&lang=js&"
export * from "./PermohonanThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports